import type { ContentGridProps } from './ContentGrid.types';

const ContentGrid: React.FC<ContentGridProps> = ({
  title,
  showTitle,
  content,
  isCentered,
  items,
}) => (
  <div
    className={`content-grid-block ${isCentered ? 'content-grid--centered' : ''}`}
  >
    <div className="content-grid-block__main">
      {title && showTitle && (
        <h2 className="content-grid-block__heading">{title}</h2>
      )}
      {content && (
        <div
          className="content-grid-block__content"
          dangerouslySetInnerHTML={{ __html: content }}
        />
      )}
    </div>
    <div className="content-grid-block__items">
      {items.map((item, index) => (
        <div className="content-grid-item" key={index}>
          <h4 className="content-grid-item__heading">{item.title}</h4>
          <div
            className="content-grid-item__content"
            dangerouslySetInnerHTML={{ __html: item.content }}
          />
        </div>
      ))}
    </div>
  </div>
);

export default ContentGrid;
